import React, { useEffect } from 'react';
import { ClerkLoaded, ClerkLoading, RedirectToSignIn, SignIn } from '@clerk/clerk-react';
import {
  buildAuthSiteEntryUrl,
  buildLocalAuthPath,
  getAuthSiteConfig,
  isClerkSatelliteHost,
  resolveRequestedRedirectUrl,
} from '@/lib/auth';
import { enterMixpanelReplaySurface, leaveMixpanelReplaySurface } from '@/lib/mixpanel';

type ExternalRedirectProps = {
  actionLabel: string;
  targetUrl: string;
};

const ExternalRedirect = ({ actionLabel, targetUrl }: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(targetUrl);
  }, [targetUrl]);

  const loadingLabel = `Redirecting to ${actionLabel}…`;

  return (
    <div className="flex h-full w-full items-center justify-center p-6 text-center text-white">
      <div>{loadingLabel}</div>
    </div>
  );
};

const SignInPage: React.FC = () => {
  const isSatelliteHost = isClerkSatelliteHost();
  const authSiteConfig = getAuthSiteConfig();
  const redirectUrl = resolveRequestedRedirectUrl('/play');
  const signUpPath = buildLocalAuthPath('/sign-up', redirectUrl);

  useEffect(() => {
    enterMixpanelReplaySurface('auth');

    return () => {
      leaveMixpanelReplaySurface('auth');
    };
  }, []);

  if (isSatelliteHost) {
    return (
      <div className="flex h-full w-full items-center justify-center p-6 text-center text-white">
        <ClerkLoading>
          <div>Loading sign-in…</div>
        </ClerkLoading>
        <ClerkLoaded>
          <RedirectToSignIn redirectUrl={redirectUrl} />
        </ClerkLoaded>
      </div>
    );
  }

  if (authSiteConfig) {
    const authSiteUrl = buildAuthSiteEntryUrl('/sign-in', redirectUrl);

    return <ExternalRedirect actionLabel="sign-in" targetUrl={authSiteUrl} />;
  }

  return (
    <div className="flex h-full w-full items-center justify-center p-6">
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl={signUpPath}
        fallbackRedirectUrl={redirectUrl}
        signUpFallbackRedirectUrl={redirectUrl}
      />
    </div>
  );
};

export default SignInPage;
